<template>
  <v-ons-page class="l-content l-document">
    <custom-toolbar backLabel="Retour">{{ title }}</custom-toolbar>

    <v-ons-list>
      <v-ons-list-item v-for="(doc, index) in documents" :key="index" @click="view(doc.filename, doc.type, doc.id)" tappable>
        <div class="center">{{ docTitle(doc) }}</div>
        <div class="right">
          <v-ons-button>
            <i class="fas fa-eye"></i>
          </v-ons-button>
        </div>
      </v-ons-list-item>
    </v-ons-list>
  </v-ons-page>
</template>

<script>
export default {
  data() {
    return {
      user: loggedIn,
      documents: [],
      url_erp: url_erp,
    };
  },
  methods: {
    view(filename, type, id) {
      var file_path = '/customers/' + this.user.pro_id + '/documents/';
      if(type == 'order') {
        var file_path = '/devis/' + id + '/';
      }
      // window.open(url_erp + file_path + filename, '_blank', 'location=no,enableViewportScale=yes');
      window.open('https://docs.google.com/viewer?url=' + url_erp + file_path + filename + '&embedded=true', '_blank', 'location=no');
    },
    docTitle(doc) {
      if(typeof doc.titleFR == 'string') {
        if(this.$i18n.locale == 'fr' && doc.titleFR) {
          return doc.titleFR;
        }
        if(this.$i18n.locale == 'nl' && doc.titleNL) {
          return doc.titleNL;
        }
      }
      return doc.filename;
    }
  },
  created() {
    let self = this;

    axios
      .get('/users/documents', {
        params: {
          'x-secundo-auth': self.user.token,
          'prospect_id': self.user.pro_id,
          'category_id': self.category_id,
        }
      })
      .then(response => {
        self.documents = response.data;
      });
  }
};
</script>


// WEBPACK FOOTER //
// DocumentsList.vue?166f2bf4